import { Swiper } from "swiper";
import { Navigation } from "swiper/modules";

class ContentPostSlider {
  constructor() {
    this.init();
  }

  init = () => {
    const slider = new Swiper(".js-cps-slider", {
      modules: [Navigation],
      slidesPerView: "auto",
      loop: true,
      spaceBetween: 20,
      navigation: {
        prevEl: ".js-cps-prev",
        nextEl: ".js-cps-next",
      },
    });
  };
}

new ContentPostSlider();
